import type { ParagraphAudienceMatch as ParagraphAudienceMatchData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphAudienceMatch.module.css";

/**
 * Layout 57 - `PARAGRAPH_AUDIENCE_MATCH_LAYOUT`: "Dla kogo".
 *
 * Struktura:
 *   - Eyebrow (text_1) + tytul H2 (name) + intro (text)
 *   - Grid 2-kol z kart {name, desc} - kazda z zielona ikona check (jednolita, badge-style)
 *   - Opcjonalna karta wykluczen (heading + lista em-dash bullets)
 */
export function ParagraphAudienceMatch({
  paragraph,
}: {
  paragraph: ParagraphAudienceMatchData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, text: intro, items, notes } = paragraph;
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasIntro = intro && intro.trim() !== "";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasIntro ? <p className={styles.intro}>{intro}</p> : null}
      </div>

      {hasItems ? (
        <div className={styles.grid}>
          {items.map((it, idx) => (
            <div key={idx} className={styles.card}>
              <span className={styles.checkIcon} aria-hidden="true" />
              <div className={styles.cardText}>
                {it.name ? <h3 className={styles.cardName}>{it.name}</h3> : null}
                {it.desc ? <p className={styles.cardDesc}>{it.desc}</p> : null}
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {notes ? (
        <div className={styles.notes}>
          <h3 className={styles.notesTitle}>{notes.title}</h3>
          <ul className={styles.notesList}>
            {notes.items.map((line, idx) => (
              <li key={idx} className={styles.notesItem}>
                <span className={styles.notesDash} aria-hidden="true">-</span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}
